module.exports = __webpack_public_path__ + "static/media/ticket.fb767668.svg";